import React from 'react';
import { useReveal } from '../lib/useReveal';
export function ProblemSection() {
  const [ref1, vis1] = useReveal();
  const [ref2, vis2] = useReveal();
  const [ref3, vis3] = useReveal();
  const [ref4, vis4] = useReveal();
  const [ref5, vis5] = useReveal();
  return <section className="relative py-28 md:py-36 px-4 overflow-hidden bg-[#f0eaf7]" data-id="element-179">
      <div className="absolute inset-0 pointer-events-none" data-id="element-180">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-purple-200/30 rounded-full blur-[120px]" data-id="element-181"></div>
        <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-amber-100/20 rounded-full blur-[100px]" data-id="element-182"></div>
      </div>

      <div className="container mx-auto max-w-2xl relative z-10" data-id="element-183">
        <div ref={ref1} className={`reveal text-center mb-16 ${vis1 ? 'is-visible' : ''}`} data-id="element-184">
          <div className="inline-flex items-center gap-2 text-amber-700/70 text-sm font-semibold tracking-widest uppercase mb-6" data-id="element-185">
            <span className="w-8 h-px bg-amber-400/60" data-id="element-186"></span>
            Tu camino empieza aquí
            <span className="w-8 h-px bg-amber-400/60" data-id="element-187"></span>
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-gray-900 leading-tight" data-id="element-188">
            Si llegaste hasta acá,
            <br data-id="element-189" />
            no fue por casualidad
          </h2>
        </div>

        <div ref={ref2} className={`reveal relative bg-white/80 backdrop-blur-sm rounded-2xl px-8 py-8 md:px-10 md:py-10 mb-14 border border-amber-200/50 shadow-[0_4px_40px_rgba(217,119,6,0.06)] ${vis2 ? 'is-visible' : ''}`} style={{
        transitionDelay: '100ms'
      }} data-id="element-190">
          <span className="absolute -top-4 left-8 text-6xl font-serif text-amber-300/50 leading-none select-none" data-id="element-191">
            "
          </span>
          <p className="text-xl md:text-2xl font-serif italic text-gray-700 leading-relaxed text-center pt-2" data-id="element-192">
            ¿Sentís que hay algo en vos que quiere sanar… pero no sabés bien por
            dónde empezar?
          </p>
          <span className="absolute -bottom-6 right-8 text-6xl font-serif text-amber-300/50 leading-none select-none rotate-180" data-id="element-193">
            "
          </span>
        </div>

        <div ref={ref3} className={`reveal text-center space-y-8 mb-14 ${vis3 ? 'is-visible' : ''}`} style={{
        transitionDelay: '150ms'
      }} data-id="element-194">
          <p className="text-lg md:text-xl text-gray-500 leading-relaxed" data-id="element-195">
            No es falta de espiritualidad. No es falta de sensibilidad.
          </p>
          <div className="relative inline-block" data-id="element-196">
            <div className="absolute inset-0 bg-amber-100/60 rounded-xl -rotate-[0.5deg] scale-[1.02]" data-id="element-197"></div>
            <p className="relative text-2xl md:text-3xl font-extrabold text-gray-900 px-6 py-4" data-id="element-198">
              👉 Es falta de orden y guía clara.
            </p>
          </div>
        </div>

        <div className="flex items-center justify-center gap-3 my-12 opacity-40" data-id="element-199">
          <div className="h-px w-16 bg-gradient-to-r from-transparent to-amber-500" data-id="element-200"></div>
          <div className="w-1.5 h-1.5 rotate-45 bg-amber-500" data-id="element-201"></div>
          <div className="w-2.5 h-2.5 rotate-45 border border-amber-500" data-id="element-202"></div>
          <div className="w-1.5 h-1.5 rotate-45 bg-amber-500" data-id="element-203"></div>
          <div className="h-px w-16 bg-gradient-to-l from-transparent to-amber-500" data-id="element-204"></div>
        </div>

        <div ref={ref4} className={`reveal text-center space-y-8 mb-16 ${vis4 ? 'is-visible' : ''}`} style={{
        transitionDelay: '200ms'
      }} data-id="element-205">
          <p className="text-lg md:text-xl text-gray-500 leading-relaxed max-w-lg mx-auto" data-id="element-206">
            Leés información suelta. Probás meditaciones. Sentís energía… pero
            dudás si lo estás haciendo bien.
          </p>
          <p className="text-xl md:text-2xl font-bold text-gray-900 font-serif" data-id="element-207">
            Y eso frena tu proceso…
          </p>
          <div className="w-20 h-px bg-gray-300 mx-auto" data-id="element-208"></div>
          <div className="pt-2" data-id="element-209">
            <p className="text-2xl md:text-3xl font-bold text-gray-900 font-serif leading-snug" data-id="element-210">
              Reiki no es complicado.
            </p>
            <p className="text-lg text-amber-700/80 mt-3 font-medium" data-id="element-211">
              Lo complicado es aprenderlo sin una guía clara.
            </p>
          </div>
        </div>

        <div ref={ref5} className={`reveal bg-white rounded-3xl shadow-xl border border-gray-100 overflow-hidden max-w-xl mx-auto ${vis5 ? 'is-visible' : ''}`} style={{
        transitionDelay: '250ms'
      }} data-id="element-212">
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 px-8 py-5 text-center" data-id="element-213">
            <h3 className="text-white font-serif font-bold text-lg" data-id="element-214">
              A muchas personas les pasa esto:
            </h3>
          </div>
          <div className="p-8 md:p-10" data-id="element-215">
            <ul className="space-y-5" data-id="element-216">
              {['Encuentran información suelta y contradictoria', 'Practican, pero dudan si lo hacen bien', 'Les cuesta sostener constancia', 'Sienten que podrían avanzar más'].map((item, idx) => <li key={idx} className="flex items-center gap-4 text-gray-700 text-lg" data-id="element-217">
                  <span className="flex-shrink-0 w-7 h-7 rounded-full bg-red-50 border border-red-200 flex items-center justify-center" data-id="element-218">
                    <span className="text-red-400 text-xs font-bold" data-id="element-219">✕</span>
                  </span>
                  <span data-id="element-220">{item}</span>
                </li>)}
            </ul>
            <div className="mt-10 pt-8 border-t border-gray-100" data-id="element-221">
              <p className="text-center text-lg leading-relaxed" data-id="element-222">
                <span className="text-gray-600" data-id="element-223">
                  El problema no es la falta de sensibilidad.
                </span>
                <br data-id="element-224" />
                <span className="font-bold text-amber-700 text-xl" data-id="element-225">
                  Es no tener un camino ordenado para avanzar con seguridad.
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}